import { render, staticRenderFns } from "./TabelaAlunos.vue?vue&type=template&id=79c49a7e&scoped=true&"
import script from "./TabelaAlunos.vue?vue&type=script&lang=js&"
export * from "./TabelaAlunos.vue?vue&type=script&lang=js&"
import style0 from "./TabelaAlunos.vue?vue&type=style&index=0&id=79c49a7e&prod&scoped=true&lang=css&"
import style1 from "./TabelaAlunos.vue?vue&type=style&index=1&id=79c49a7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c49a7e",
  null
  
)

export default component.exports